import { AxiosPromise } from "axios";
import { EnvironmentFactory } from "src/factory/EnvironmentFactory/environment.factory";
import { Util } from "src/utils/Util";
import { IPasswordData } from "../interfaces/IPassowrdData";

/**
 *
 */
export namespace SecurityService {

  /**
   * 
   * @param data 
   * @returns 
   */
  export const changePasswordService = (data: IPasswordData): AxiosPromise<void> => {
    return EnvironmentFactory.Http.SecureHttp().post(Util.API_PATH.CHANGE_PASSWORD, data);
  };
}